export const dropdownIcon = `
<svg width="10" height="10" style="display:inline;vertical-align: middle">
<path fill="currentColor" d="M1.667 3.333h6.667L5 6.666z" />
</svg>`;
//# sourceMappingURL=icon.js.map